<script setup lang="ts">
/**
 * Le badge d'état d'une surveillance : l'icône puis le libellé (S:5208),
 * l'état se lisant d'abord par son icône.
 */
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import type { EtatLigne, TonEtat } from "@modules/alarmes-v2/utils/etats"

// ================================
// PROPS & EMITS
// ================================
const props = defineProps<{
    /** L'état jugé par `etatDeLaLigne`. */
    etat: EtatLigne
}>()

/**
 * Les classes Tailwind de chaque ton de badge.
 */
const CLASSES_DU_TON: Record<TonEtat, string> = {
    danger: "bg-red-50 text-red-800 border-red-200",
    warn: "bg-amber-50 text-amber-800 border-amber-200",
    info: "bg-sky-50 text-sky-800 border-sky-200",
    ok: "bg-green-50 text-green-800 border-green-200",
    neutre: "bg-surface-50 text-surface-700 border-surface-200",
}

/**
 * Les classes du badge courant.
 */
const getClasses = computed((): string => CLASSES_DU_TON[props.etat.ton])
</script>

<template>
    <!-- ================================ -->
    <!-- COMPOSANT PRINCIPAL -->
    <!-- ================================ -->
    <span
        class="inline-flex items-center gap-1 whitespace-nowrap rounded border px-2 py-0.5 text-xs font-medium"
        :class="getClasses"
        :title="etat.mot"
        data-test="badge"
    >
        <span aria-hidden="true">{{ etat.icone }}</span>
        <span data-test="etat">{{ etat.mot }}</span>
    </span>
</template>
